(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/objects/action-bar-base.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/objects/action-bar-base.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.objects = svs.matchen.objects || {};

  svs.matchen.objects.ActionBarBase = Marionette.MnObject.extend({
    options: {
      objects: {
        contextMenu: null
      }
    },

    hideActionBar: function() {
      svs.sport.actionbar.hide();
      this.trigger('resize:tab:view');
    }
  });
})(Backbone, _, svs);


 })(window);